import { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import { useAuth } from "../hooks/Auth/useAuth";
import { Header } from "../components/layout/Header";
import { SupportWidget } from "../components/support/SupportWidget";
import { Footer } from '../components/layout/Footer';
import { RouteErrorBoundary } from "../components/errors/RouteErrorBoundary";

interface PracticeFormData {
  id: string;
  ein: string;
  name: string;
  DBA: string;
  primary_email: string;
  billing_email: string;
  phone: string;
  website: string;
  npi_number: string;
  npi_type: string;
}

export default function MainLayout() {
  const { isAuthenticated } = useAuth();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [formData, setFormData] = useState<PracticeFormData>({
    id: "ea974813-1728-4a02-aef5-dc61f248b89c",
    ein: "12-3456789",
    name: "Acme Inc",
    DBA: "Wile E. Coyote",
    primary_email: "contact@psychpractice.com",
    billing_email: "billing@psychpractice.com",
    phone: "+1-555-123-4567",
    website: "http://www.psychpractice.com",
    npi_number: "",
    npi_type: ""
  });

  useEffect(() => {
    // Check if user needs to complete the form
    if (isAuthenticated) {
      // For demo purposes, showing the modal
      setIsModalOpen(true);
    }
  }, [isAuthenticated]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Here you would submit the form data to your API
    setIsModalOpen(false);
  };

  return (
    <div className="min-h-screen flex flex-col bg-slate-50">
      <Header />

      <main className="">
        {/* A crash in a page renders an error card here; Header/Footer stay alive. */}
        <RouteErrorBoundary>
          <Outlet />
        </RouteErrorBoundary>
      </main>

      {isAuthenticated && <SupportWidget />}

      <Footer />

      {/* Practice Information Modal using Tailwind */}
   
    </div>
  );
}
